
import { apiBaseURL } from '../../Utils/ProjectConstants';
import useSWR from 'swr';

export default function useFetchWorkPlans(projectId) {

	const { data, error, mutate } = useSWR(`${apiBaseURL}/api/project/workplan?showDeleted=false&projectId=${projectId}`, {
		dedupingInterval: 300000,
	});
	const projectName = data?.data?.name;
	const allProjects = data?.data?.workPlans.map((x) => ({
		id: x.id,
		billingCode: x.billingCode,
		headId: x.headId,
		projectId: x.projectId,
		taskName: x.taskName,
		comments: x.comments,
		description: x.description,
		exitCriteria: x.exitCriteria,
		workOrders: x.workOrders.map((x) => ({
			id: x.id,
			name: x.name,
			billingCode: x.billingCode,
			link: x.link,
			startDate: x.startDate,
			endDate: x.endDate,
			allocatedCellHours: x.allocatedCellHours,
			actualCellHours: x.actualCellHours,
			workorderForLab: x.workorderForLab.map((x) => ({
				workCenter: x.workCenter,
				allocatedCellHours: x.allocatedCellHours,
				actualCellHours: x.actualCellHours
			}))
		})),
		durationInDays: x.durationInDays,
		startDate: x.startDate,
		endDate: x.endDate,
		actualEndDate: x.actualEndDate,
		completedPercentage: x.completedPercentage,
		isCompleted: x.isCompleted,
		supervisorIds: x.supervisorIds,
		supervisors: x.supervisors,
		allocatedEngHours: x.allocatedEngHours,
		actualEngHours: x.actualEngHours,
		actualEngHoursOPR: x.actualEngHoursOPR,
		actualEngHoursRES: x.actualEngHoursRES,
		allocatedLabHours: x.allocatedLabHours,
		actualLabHours: x.actualLabHours
	}))

	//unless it is a parent task?
	const dependencies = data?.data?.workPlans.map((x) => ({
		id: x.id,
		predecessorId: x.headId,
		successorId: x.billingCode,
		type: 0
	}))

	const resourceAssignments = data?.data?.workPlans.map((x) => ({
		taskId: x.billingCode,
		resourceId: x.supervisorIds
	}))
	resourceAssignments?.forEach((item, i) => {
		item.id = i + 1;
	});

	const upcomingProjects = data?.data?.upcomingProjects;
	const pastDueProjects = data?.data?.pastDueProjects;

	const tasks = data?.data?.workPlans.map((x) => ({
		id: x.billingCode,
		parentId: (x.headId === projectId) ? 0 : x.headId,
		title: x.taskName,
		start: new Date(x.startDate).toLocaleDateString(),
		end: new Date(x.endDate).toLocaleDateString(),
		actualEnd: new Date(x.actualEndDate).toLocaleDateString(),
		progress: x.completedPercentage
	}))

	return {
		projectName,
		allProjects,
		dependencies, 
		resourceAssignments, 
		tasks,
		upcomingProjects,
		pastDueProjects,
		error,
		isLoading: !error && !data,
		mutate,
	};
}